import React from 'react';

const UnableToConfirm: React.FC = () => {
	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>
						We’re sorry! Your verification code could not be confirmed. Please call
						{' '}
						<span className="inline-block">
							<a href="tel:+8553272325" className="inline-link">
								(855) 327-2325
							</a>
						</span>
						{' '}
						to help finalize your booking.
					</p>
					<p>Thank you for your patience!</p>
				</div>
			</div>
		</div>
	);
};

export default UnableToConfirm;
